import { t } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import {
    PANEL_CATEGORIES,
    PANEL_PRIORITIES,
    STATUS_CHART_PANEL_PREVIEW_IMAGE,
} from '../../page-framework/panel/PanelRegistry';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import StatusChartPanel from '../status-chart-panel/StatusChartPanel';
import { entityType } from '../../filters/radio-filter/RadioFilter';
import { radioFilterId, timeRangeFilterId } from '../../filters';

const title = t`Radio Status`;

function RadioStatusPanel() {
    return <StatusChartPanel entityType={entityType} />;
}

RadioStatusPanel.propTypes = {
    ...panelPropTypes,
};

RadioStatusPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 40,
    minContentHeight: 40,
    disableVerticalResize: true,
};

export default Panel({
    typeAlias: 'RadioStatusBreakout',
    catalogEntry: {
        category: PANEL_CATEGORIES.RADIO,
        priority: PANEL_PRIORITIES.STATUS,
        title,
        description: t`Status trend for a selected radio`,
        previewImage: STATUS_CHART_PANEL_PREVIEW_IMAGE,
        ipm: true,
    },
    filters: {
        required: [timeRangeFilterId, radioFilterId],
        optional: [],
    },
})(RadioStatusPanel);
